<div class="tw-bg-orange-25 tw-pb-[26px]" (click)="handleClick()">
  <div class="tw-flex tw-items-center tw-justify-center">
    <div class="tw-relative tw-inline-block">
      <img src="https://cdn.cureskin.com/app/img/Exclamation.gif" alt="regimen-expiry-banner" class="tw-w-[104px] tw-h-[104px] tw-relative tw-z-10 tw-mix-blend-multiply tw-mt-1">
      <div class="tw-absolute tw-inset-0 tw-bg-orange-25 tw-z-0"></div>
    </div>
  </div>
  <ng-content select="[slot=header]"></ng-content>
  <ng-content select="[slot=sub-header]"></ng-content>
  <ng-content select="[slot=button]"></ng-content>
</div>
